import * as React from "react";

const FontAwesome = require("react-fontawesome");

const styles = require("./styles.module.scss");

const ValidationErrorsAlert = ({ errors }: { errors: string[] }) => (
  <div className={styles.container}>
    <FontAwesome className={styles.icon} name="warning" />
    <div className={styles.text}>
      {errors.map((msg: string) => (
        <div key={msg} className={styles.headline}>
          {msg}
        </div>
      ))}
      <div className={styles.detail}>
        Fix value{errors.length > 1 ? "s" : ""}, or click the cancel button to cancel all changes.
      </div>
    </div>
  </div>
);

export default ValidationErrorsAlert;
